import React from 'react';
import Wallet from '../../components/Wallet/Wallet';

// Screen for wallet from menu navigation
const ViewWallet = () => {
  return <Wallet />;
};

export default ViewWallet;
